import { Tokens } from '@tmov/design-system/theme/types';
import styled from 'styled-components';

export const TableContainer = styled.div`
  padding-top: 32px;

  overflow: visible;
  background-color: ${Tokens.eixods.colors.neutral.grey[0]};
  padding: 32px;
  border-radius: 8px;
`;

export const PropostaHeader = styled.h3`
  width: 468px;
  height: 31px;

  text-align: left;

  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 130%;

  margin-bottom: 5px;

  color: ${Tokens.eixods.colors.neutral.grey[100]};
`;

export const PropostaSubtitle = styled.h3`
  width: 468px;
  height: 21px;

  text-align: left;

  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;

  margin-bottom: 24px;

  color: ${Tokens.eixods.colors.neutral.grey[70]};
`;

export const HeaderRight = styled.div`
  gap: 24px;
  display: flex;
  float: right;
`;

export const Header = styled.div``;
